import React from 'react'
import PropTypes from 'prop-types'

import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { formatPrice } from 'common/utils/format'
import ProductPriceTypography from 'artkive/components/PageSections/ProductPriceTypography'
import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'

const useStyles = makeStyles((theme) => ({
  priceInfoBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    gap: '16px',
    marginTop: '24px',
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
      marginTop: '16px',
    },
  },
  priceTextBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      gap: '16px',
    },
  },
  priceTextInnerBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      gap: 0,
      alignItems: 'flex-start',
      textAlign: 'left',
    },
  },
  sizeText: {
    color: theme.colors.grey[950],
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: 1.6,
    textTransform: 'uppercase',
  },
  additionalText: {
    fontWeight: 600,
  },
  asteriskBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '4px', // TODO: it looks different from other asterisks boxes
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
      textAlign: 'left',
    },
  },
  price: {
    minWidth: '81px',
  },
}))

const MosaicPrices = ({ large, small, asterisks }) => {
  const classes = useStyles()
  const isMobile = useMobileBreakpoint()

  const getSizeText = (product) => {
    return (
      <Typography className={classes.sizeText}>
        {product.name} {product.width}"X{product.height}"
      </Typography>
    )
  }

  return (
    <Box className={classes.priceInfoBox}>
      <Box className={classes.priceTextBox}>
        {isMobile && getSizeText(large)}
        <ProductPriceTypography className={classes.price}>
          {formatPrice(large.non_bundle_price, 'short')}
        </ProductPriceTypography>
        <Box className={classes.priceTextInnerBox}>
          {!isMobile && getSizeText(large)}
          <Typography className={classes.additionalText}>
            {formatPrice(large.price, 'short')} bundled with a Book purchase
          </Typography>
        </Box>
      </Box>
      <Box className={classes.priceTextBox}>
        {isMobile && getSizeText(small)}
        <ProductPriceTypography className={classes.price}>
          {formatPrice(small.non_bundle_price, 'short')}
        </ProductPriceTypography>{' '}
        <Box className={classes.priceTextInnerBox}>
          {!isMobile && getSizeText(small)}
          <Typography className={classes.additionalText}>
            {formatPrice(small.price, 'short')} bundled with a Book purchase
          </Typography>
        </Box>
      </Box>
      {!!asterisks.length && (
        <Box className={classes.asteriskBox}>
          {asterisks.map((asterisk, index) => (
            <Typography variant='caption' key={index}>
              {asterisk}
            </Typography>
          ))}
        </Box>
      )}
    </Box>
  )
}

MosaicPrices.propTypes = {
  large: PropTypes.shape({
    non_bundle_price: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired,
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  small: PropTypes.shape({
    non_bundle_price: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired,
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  asterisks: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default MosaicPrices
